import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../api";
import { useCompany } from "../Company/CompanyContext";
import { toast } from "react-toastify";
import { FaTrash, FaPlus, FaGripVertical } from "react-icons/fa";

export default function PaymentMethodsTab({ raw }) {
  const { t } = useTranslation();
  const { reload } = useCompany();
  const [methods, setMethods] = useState(() => {
    try { return JSON.parse(raw.payment_methods || "[]"); }
    catch { return ["Virement", "Chèque", "Espèces", "CB", "Prélèvement"]; }
  });
  const [newMethod, setNewMethod] = useState("");
  const [saving, setSaving]       = useState(false);

  const add = () => {
    const v = newMethod.trim();
    if (!v || methods.includes(v)) return;
    setMethods((m) => [...m, v]);
    setNewMethod("");
  };

  const remove = (i) => setMethods((m) => m.filter((_, idx) => idx !== i));

  const moveUp   = (i) => { if (i === 0) return; const m = [...methods]; [m[i-1], m[i]] = [m[i], m[i-1]]; setMethods(m); };
  const moveDown = (i) => { if (i === methods.length - 1) return; const m = [...methods]; [m[i], m[i+1]] = [m[i+1], m[i]]; setMethods(m); };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", { payment_methods: JSON.stringify(methods) });
      await reload();
      toast.success(t("settings.payment.saved"));
    } catch {
      toast.error(t("settings.common.saveError"));
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-lg">
      <p className="text-sm text-base-content/60">
        {t("settings.payment.intro")}
      </p>

      <ul className="space-y-2">
        {methods.map((m, i) => (
          <li key={i} className="flex items-center gap-2 bg-base-200 rounded-lg px-3 py-2">
            <FaGripVertical className="text-base-content/30 cursor-grab" />
            <span className="flex-1 text-sm font-medium">{m}</span>
            <button onClick={() => moveUp(i)}   className="btn btn-ghost btn-xs px-1" title={t("settings.prestations.up")}>↑</button>
            <button onClick={() => moveDown(i)} className="btn btn-ghost btn-xs px-1" title={t("settings.prestations.down")}>↓</button>
            <button onClick={() => remove(i)}   className="btn btn-ghost btn-xs text-error px-1" title={t("settings.prestations.remove")}>
              <FaTrash />
            </button>
          </li>
        ))}
      </ul>

      <div className="flex gap-2">
        <input
          type="text"
          value={newMethod}
          onChange={(e) => setNewMethod(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder={t("settings.payment.addPlaceholder")}
          className="input input-bordered input-sm flex-1 bg-base-200 border-base-300 focus:border-primary focus:outline-none"
        />
        <button onClick={add} className="btn btn-sm btn-ghost border border-base-300">
          <FaPlus /> {t("settings.prestations.add")}
        </button>
      </div>

      <div className="flex justify-end">
        <button onClick={save} disabled={saving} className="btn btn-primary">
          {saving ? t("settings.prestations.saving") : t("settings.prestations.save")}
        </button>
      </div>
    </div>
  );
}
